import { SS, SS_MA, DASHWV, DASHWV_MA, DASHPR, DASHPR_MA, HLS } from 'src/AAFPlayer/constants';
import { getConfigSS } from './streams-types-config/smoothStream';
import { getConfigDashWV } from './streams-types-config/dashWideVine';
import { getConfigDashPR } from './streams-types-config/dashPlayReady';
import { getConfigHLS } from './streams-types-config/HLS';

const gerConfigDefault = (options) => {
    const config = {
        title: 'Art of Motion',
        poster: options.backgroundImage,
        progressive:
        'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4?t=' +
        (Math.random()).toString(),
    };
    return config;
};

export const configSourceStreamTypes = (options) => {
    const streamType = options.streamType;
    switch (streamType) {
        case SS:
        case SS_MA:
            return getConfigSS(options);
        case DASHWV:
        case DASHWV_MA:
            return getConfigDashWV(options);

        case DASHPR:
        case DASHPR_MA:
            return getConfigDashPR(options);

        case HLS:
            return getConfigHLS(options);

        default:
            return gerConfigDefault(options);
    }
};



// WEBPACK FOOTER //
// ./src/devices/all/bitmovin/utils/configSourceStreamTypes.js